module.exports = __webpack_public_path__ + "static/forecast/weather/daypartcloud-5805558b340e278d9e6b993a334f4607.svg";